import { AfterViewInit, Directive, ElementRef, Input, inject } from '@angular/core';
import { AuthService, AuthCheck } from '../services';

@Directive({
    selector: '[appAuthorize]',
    standalone: true,
})
export class AuthorizeDirective implements AfterViewInit {
    private el = inject(ElementRef);
    private auth = inject(AuthService);

    @Input('appAuthorize') authCheck?: string[] | AuthCheck | string;

    ngAfterViewInit(): void {
        const check = typeof this.authCheck === 'string' ? [this.authCheck] : this.authCheck;
        this.auth.isAuthorize(check).subscribe((access: boolean) => {
            if (!access && this.el.nativeElement?.style) {
                this.el.nativeElement.style.display = 'none';
            }
        });
    }
}
